import Grid from 'apollo-react/components/Grid';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import MiddlePanel from './MiddlePanel';
import RightPanel from './RightPanel';
import { setPanelLayoutConfig, setRightPanelMount } from '../../../actions/PanelLayoutActions';
import { DOCUMENT_VIEWER } from '../../../constants/Urls';
import { getTaskStatusDisabled } from '../../../containers/EntityDisplay/TaskStatus/selectors';
import { FORM_KEYS } from '../../../form-designer/constants/form-manager.constants';
import { getPanelLayout, isFormLoading } from '../../../form-designer/selectors/common.selectors';
import { getIsArchiveMode } from '../../../selectors/AuthSelectors';
import { PanelContext } from '../../../utils/PanelConfig';

function MobilePanelLayout({
  leftPanelDisabled,
  middlePanelChildren,
  middlePanelFormFooter,
  rightPanelChildren,
  rightPanelDisabled,
  panelsProps = {},
}) {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { config, configLocked, isRightPanelMounted } = useSelector(getPanelLayout);
  const hasStepForm = !useSelector(isFormLoading(FORM_KEYS.STEP));
  const hasDetailForm = !useSelector(isFormLoading(FORM_KEYS.DETAIL));
  const isTaskStatusPanelDisabled = useSelector(getTaskStatusDisabled);
  const isArchiveMode = useSelector(getIsArchiveMode);

  const setConfig = useCallback((config) => dispatch(setPanelLayoutConfig(config)), [dispatch]);
  const mountRightPanel = useCallback(() => dispatch(setRightPanelMount()), [dispatch]);

  const isMiddlePanelEnabled = hasStepForm || (hasDetailForm && DOCUMENT_VIEWER === pathname);

  const configProps = {
    config,
    setConfig,
  };

  return (
    <Grid style={{ height: '100%' }} container spacing={0}>
      <PanelContext.Provider value={{ layout: 'md' }}>
        <MiddlePanel
          {...configProps}
          hideButtons={configLocked}
          hideLeftButton={leftPanelDisabled}
          hideRightButton={rightPanelDisabled}
          middlePanelFormFooter={middlePanelFormFooter}
          panelProps={panelsProps.middlePanel}
          mountRightPanel={mountRightPanel}
          isRightPanelMounted={isRightPanelMounted}
          isMobileDevice={true}
        >
          {middlePanelChildren}
        </MiddlePanel>
      </PanelContext.Provider>
      <PanelContext.Provider value={{ layout: 'rt' }}>
        <RightPanel
          {...configProps}
          hideButtons={configLocked}
          isMiddlePanelEnabled={isMiddlePanelEnabled}
          isRightPanelMounted={isRightPanelMounted}
          isTaskStatusPanelEnabled={!isArchiveMode && !isTaskStatusPanelDisabled}
          panelProps={panelsProps.rightPanel}
          isMobileDevice={true}
        >
          {rightPanelChildren}
        </RightPanel>
      </PanelContext.Provider>
    </Grid>
  );
}

export default MobilePanelLayout;
